import {
  MESSAGE_FETCH_REQUEST,
  MESSAGE_CREATE_REQUEST,
  MESSAGE_UPDATE_REQUEST,
  MESSAGE_DELETE_REQUEST,
  MESSAGE_START_LISTEN_REQUEST,
  MESSAGE_STOP_LISTEN_REQUEST,
  MESSAGE_CLEAR,
} from 'store/constants/messageTypes';

export function fetchMessagesAction({ groupId, threadId, since }: any) {
  return {
    type: MESSAGE_FETCH_REQUEST,
    payload: { groupId, threadId, since },
  };
}

export function createMessageAction({
  accountIds,
  body,
  emailIntegrationId,
  formName,
  groupId,
  isNewMessage = false,
  allSelected = false,
  leadIds,
  scheduledAt,
  shouldFetchMessages,
  subject,
  threadId,
  threadType = 'text',
  filters,
  fileIds,
}: any) {
  return {
    type: MESSAGE_CREATE_REQUEST,
    payload: {
      accountIds,
      body,
      emailIntegrationId,
      formName,
      groupId,
      isNewMessage,
      allSelected,
      leadIds,
      scheduledAt,
      shouldFetchMessages,
      subject,
      threadId,
      threadType,
      filters,
      fileIds,
    },
  };
}

// Only for scheduled messages
export function updateMessageAction({
  id,
  groupId,
  body,
  scheduledAt,
}: {
  id: number;
  groupId: number;
  body: string;
  scheduledAt: string;
}) {
  return {
    type: MESSAGE_UPDATE_REQUEST,
    payload: { id, groupId, body, scheduledAt },
  };
}

// Cancels a scheduled message, the API keeps it with a "canceled" status
export function deleteMessageAction({
  id,
  groupId,
}: {
  id: number;
  groupId: number;
}) {
  return {
    type: MESSAGE_DELETE_REQUEST,
    payload: { id, groupId },
  };
}

export function clearMessagesAction() {
  return {
    type: MESSAGE_CLEAR,
  };
}

export function startListeningForMessagesAction({ threadId }: any) {
  return {
    type: MESSAGE_START_LISTEN_REQUEST,
    payload: { threadId },
  };
}

export function stopListeningForMessagesAction() {
  return {
    type: MESSAGE_STOP_LISTEN_REQUEST,
  };
}
